/*
    此文件为数据接口存放命名，为防止接口太多，造成接口混乱
    命名为大写斜杠
    按页面划分
    例如： 'ORDER_API': '/api/order',
    每个接口注释用途，为方面其他开发人员查找，了解。
    export default {

    }
*/
export default {
  /**获取列表 */
  USER_LIST_API: '/sales/order/listOrderByPage',
  /**新增/修改合同*/
  SAVE_ORDER_API: '/sales/order/saveOrder',
  /*保存之前校验*/
  BEFORE_SAVE_ORDER_API: '/sales/quantityLimit/checkAvailableAmount',
  /**实时计算*/
  GET_SALES_ORDERNO_BY_ORDER_TRADE_API: '/sales/order/getSalesOrderNoByOrderTrade',
  /**实时计算*/
  CAL_AMOUNT_ORDER_API: '/sales/order/getOrderTotal',
  /**删除合同*/
  DELETE_ORDER_API: '/sales/order/batchDeleteOrder',
  /**合同查询*/
  GET_LIST_API: '/sales/order/listOrderByPage',
  /*导出合同**/
  EXPORT_ORDER_API: '/sales/order/exportOrder',
  /**获取合同详情*/
  GET_ORDER_DETAIL_API: '/sales/order/getOrder',
  /**批量提交合同*/
  SUBMIT_ORDER_API: '/sales/order/batchAuditCommit',
  /**保存行项目*/
  SAVE_ORDERPRICE_API: '/sales/orderSaleDetailPricing/savePricing',
  /***/
  UPDATE_ORDERSALEDETAIL_API: '/sales/orderSaleDetailPricing/selectDetailByContractNo',
  /**行项目计算*/
  // 'CAL_AMOUNT_ORDER_API': '/sales/order/getOrderTotal',
  /**年度协议计算*/
  CAL_YEAR_ORDER_API: '/sales/order/getYearContractLocal',
  /**运输货币转换*/
  CAL_DELIVERY_API: '/sales/order/getDeliveryLocal',
  /**获取点价详情*/
  GET_ORDERSALEDETAIL_API: '/sales/orderSaleDetailPricing/selectByContractNo',
  /**获取单价历史详情-海宁 销售*/
  GET_ORDERHISTORYDETAIL_API: '/sales/orderPriceHistory/selectRevisedOrderDetailHistoryHn',
  /**海宁单采，双边获取点价详情*/
  GET_ORDERSALEDETAIL_API_HN: '/sales/orderPriceHistory/selectRevisedOrderPriceHistoryHn',
  /**校验是否可以提单*/
  CHECK_ORDER_API: '/sales/order/checkLadingQuantity',
  /** 结算批次*/
  GET_SETTLE_API: '/sales/orderSettle/listOrderSettleOther',
  /**  合同导入*/
  IMPORT_ORDER_API: '/sales/order/importOrder',
  IMPORT_ORDER_API_CK: '/sales/order/ck/importOrder',
  /** 货币 */
  GET_LEGER_CODE_NAME: '/maindata/ledger/codeName',
  /**关闭激活撤销合同 */
  UPDATE_OTDER_STATUS: '/sales/order/updateOrderStatus',
  UPDATE_OTDER_STATUSHN: '/sales/OUT_REQ/order/updateOrderStatusHn',
  /** 信用额度提交校验*/
  CHECK_AVAILABLE_AMOUNT: '/sales/creditLimitSummary/checkAvailableAmount',

  /** 海宁信用额度提交校验*/
  CHECK_AVAILABLE_AMOUNT_HN: '/sales/creditLimitSummary/checkAvailableHnOrderAmount',

  /**供应商发货指令 */
  CHECK_SHIPPING_API: '/sales/order/checkShippingInstruction',
  /**  历史   */

  /* * 销售-物流信息 */
  LIST_PICKING: '/warehouse/storageLade/listStorageLadingPickingByContract',
  /* *销售-物流信息-提单数量 */
  LIST_STORAGE_QUANTITY: '/warehouse/storageLade/listStorageLadingQuantityByContract',
  /* *销售-物流信息-出库数量 */
  LIST_OUTBOUND_QUANTITY: '/warehouse/outBound/listStorageLadingQuantityByContract',
  /* *销售-发票-查询 */
  LIST_STATISTICAL: '/financial/financeSalesInvoice/getFinanceSalesInvoiceStatisticalInfo',
  /* *销售-发票-合计 */
  GET_QUANTITY: '/financial/financeSalesInvoice/getInvoicedQuantity',
  /* *采购-发票-查询 */
  LIST_STATISTICAL_P: '/financial/payment/getFundPayableInvoiceStatisticalInfo',
  /* *采购-发票-合计 */
  GET_QUANTITY_P: '/financial/payment/getInvoicedQuantity',
  /* *采购-物流信息 */
  LIST_SALES: '/warehouse/shippingInstruction/listStorageInstructionForOrder',
  /* *采购-物流信息- 供应商发货指令*/
  LIST_SALES_SHIPPING: '/warehouse/shippingInstruction/listStorageInstructionForOrderRowNo',
  /* *采购-物流信息- 物流入库数*/
  LIST_SALES_DISTRIBUTION:
    '/warehouse/distributionInbound/listDistributionInboundProductForOrderRowNo',
  /* *采购-物流信息- 业务入库数*/
  LIST_SALES_BUSINESS: '/warehouse/businessInbound/listBusinessInboundForOrderRowNo',
  /* * 付款 采购*/
  PAY_LIST: '/financial/fundPayment/queryPayListByContractNo',
  /* * 收款 销售*/
  COllECT_LIST: '/financial/fundCollectionClaim/getFundCollectionByContractNo',
  /** 加法计算 */
  GET_ADD_AMOUNT: '/sales/orderSalesReturn/getAddAmount',
  // 合作伙伴详情
  GET_PARTNERINFOFORHN: '/maindata/partnersApi/getPartnerInfo',
  // 风控审批
  POST_REVERT_API: '/sales/order/approvalOrderStatusForUndo',
  //意向单审批中和修订审批中确认操作
  POST_CONFIRM_API: '/sales/order/confirmOperation',

  // 订单批量生成付款申请
  BATCH_TO_PAYAPPLY_BY_ORDER: 'financial/paymentApply/batchCreateByOrderAndSave',
  // 海宁订单查询外部确认详情   入参：{orderId：}
  ORDER_CONFIRM: '/sales/orderPriceHistory/selectOrderConfirmHistoryHn',
  // post 方法 检验外部合同号
  CHECK_EXTERNAL_CONTRACTNO: '/sales/order/checkExternalContractNo',
  // 合同变动单价修改计算
  CAL_AMOUNT_ORDER_API_CHANGE: '/sales/order/calForVariablePrice',
  //供应商确认
  UPDATE_STATUS_BY_SUPPLIER: '/sales/OUT_REQ/orderTrade/updateStatusBySupplier',
  //校验商品是否属于该公司
  CHECK_PRODCT_COMPANY: '/maindata/productDetail/checkProductDetailCompany',

  //合同-更新合同正本已收（业务）:入参：{'contractNo':,'originalsReceivedBusiness':}
  UPDATE_ORDER_ORB: '/sales/order/updateOriginalsReceivedBusiness',
  //合同-更新合同正本已收（风控）:入参：{'contractNo':,'originalsReceivedRm':}
  UPDATE_ORDER_ORR: '/sales/order/updateOriginalsReceivedRm',
  // 删除申请
  DELETE_CONTRACT_COMMIT: '/sales/order/deleteContractCommit',
  // 销售订单转转款单
  SALE_TO_TRANSFER: '/financial/transfer/salesToTransfer',
  // 销售订单转转款单--校验
  SALE_TO_TRANSFER_CHECK: '/financial/transfer/checkExistsTransfer',

  // 获取合同带有多个商品接口   贸易
  STATEMENT_CONTRACT_LIST_API: '/sales/orderDetail/orderInfoAndDetailByPage',

  // 获取合同   多式联运
  MULTRANSPORT_CONTRACT_LIST_API: '/sales/mto/contract/listMtoContractByPage',

  // 获取合同   园区仓储
  PARKWAREHOUSE_CONTRACT_LIST_API: '/sales/contractInfo/listContractByPage',
  // 打印合同
  EXPORT_PRINT_API: '/sales/order/exportPrint',
  // 根据合同编码获取客户数据 多式联运
  GET_CUSTOMER_BY_CONTRACT: '/sales/mto/contract/getAllCustomerList',
};
